import { HudButton } from 'components/HudButton'
import { FloatWindow } from 'features/chatbot/components/FloatWindow'
import React from 'react'
import styled from 'styled-components'

const FloatingButtonContainer = styled.div`
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  z-index: 1000;
`

type FloatButtonProps = {
  isOpen: boolean
  onClick: () => void
  icon: React.ReactNode
  children: React.ReactNode
}

export const FloatButton: React.FC<FloatButtonProps> = ({
  isOpen,
  onClick,
  children,
  icon,
}) => {
  return (
    <>
      <FloatingButtonContainer>
        <HudButton
          icon={icon}
          isSelected={isOpen}
          onClick={onClick}
          animation='scale'
          scaleAmount={1.1}
          hasBorder
        />
      </FloatingButtonContainer>
      {isOpen && <FloatWindow>{children}</FloatWindow>}
    </>
  )
}
